import { apiClient } from './axiosSettings'

export async function getQueueStatus(endpoint: string,payload:any, source:any , headers:any) {
  return apiClient.post(`${endpoint}/api/queue/status`,payload, { cancelToken: source.token , headers: headers })
}
